import parseToReact from "html-react-parser";
import {has} from "lodash";
import slugify from "@sindresorhus/slugify";
import {ContentApiDef} from "@dnhb/content-api-client";
import {Entry} from "@dnhb/content-api-client/src/contract/notion";

type slugifyDef = (
  self: ContentApiDef,
  model: string,
  target: string,
  property: string,
  page: Entry
) => string;

export const getProperty: slugifyDef = (
  self,
  model,
  target,
  property,
  entry
) => {
  const hasProp = has(entry.properties, property) ? entry.properties[property] : null;

  return hasProp;
}

export const slugifyEntry: slugifyDef = (
  self,
  model,
  target,
  property,
  entry
) => {
  if (!entry.slug || entry.slug.length < 8) throw new Error(`Invalid slug for ${entry.id}`);

  return entry.slug;
}

export const slugifyTopic: slugifyDef = (
  self,
  model,
  target,
  property,
  entry
) => {
  const slug = slugifyEntry(self, model, target, property, entry);

  return slug && slugify(slug.slice(0, slug.length - 8)); // remove uuid fragment
}

type ParseDef = (
  content: string,
  options?: { [key: string]: any },
) => any;

export const parse: ParseDef = (
  content,
  options = {}
) => {
  return parseToReact(content, options);
}
